export interface MaintenanceState {
  enabled: boolean;
  /** l10n 시트 등록 키 (정상 운영 패턴) — 클라가 `t(messageKey)` 로 표시 */
  messageKey?: string;
  /** 긴급 시 자유 텍스트 (locale 분기 없음, 그대로 노출) */
  customMessage?: string;
  /** 레거시 호환 — messageKey/customMessage 가 없을 때 fallback 으로만 사용 */
  message?: string;
  updatedAt?: number;
  updatedBy?: string;
}

/**
 * 점검 모드 ON 시 비-admin user RPC 가 throw 하는 에러 코드. 클라는 maintenance
 * overlay 가 이미 떠 있어 추가 처리 불필요.
 */
export const MAINTENANCE_ACTIVE_CODE = 'MAINTENANCE_ACTIVE';

/**
 * 점검 상태가 토글될 때 서버(`setMaintenanceState`)가 접속 중인 모든 클라에
 * `$global.broadcastToAll` 로 보내는 global 메시지 타입. 클라는 이 메시지만
 * 구독해 `maintenance` 상태를 갱신한다 — global state 전체를 sync 하지 않는다.
 * payload 는 `MaintenanceState`.
 */
export const MAINTENANCE_CHANGED_MESSAGE = 'maintenance:changed';

/** 점검 상태 기본값(OFF). R2 미발행/파싱 실패 시 폴백. */
export const EMPTY_MAINTENANCE_STATE: MaintenanceState = { enabled: false };

/**
 * R2 `rb-maintenance/{channel}/maintenance.json` canonical 형태.
 * 클라는 자기 flavor 섹션만 읽는다(`pickFlavor`).
 */
export interface MaintenanceConfig {
  web2: MaintenanceState;
  web3: MaintenanceState;
}
